import clsx from "clsx"
import React from "react"
import "../styles/RFBadge.scss"

type BadgeProps = React.PropsWithChildren<unknown> & {
    size?: "medium"
    status: "processing" | "success" | "failed" | "canceled"
}

export const RFBadge = ({ children, size = "medium", status }: BadgeProps) => {
    return <span className={clsx("rfbadge", `rfbadge-${size}`, `rfbadge-${status}`)}>{children}</span>
}


// WEBPACK FOOTER //
// ./src/payment-processing/components/RFBadge.tsx